import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, isRef as _isRef, withCtx as _withCtx, createElementVNode as _createElementVNode, vModelText as _vModelText, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeStyle as _normalizeStyle, vModelCheckbox as _vModelCheckbox, vModelRadio as _vModelRadio, createTextVNode as _createTextVNode, withKeys as _withKeys, vShow as _vShow, Fragment as _Fragment } from "vue"
import _imports_0 from './assets/github-mark-white.svg'
import _imports_1 from './assets/world-map-coordinates-correct.png'
import _imports_2 from './assets/sundialicon.svg'
import _imports_3 from './assets/pointshadowtraceicon.svg'
import _imports_4 from './assets/snapmode.svg'
import _imports_5 from './assets/orbitmode.svg'


const _hoisted_1 = { style: {"width":"100%","height":"100%","position":"fixed","left":"0","top":"0"} }
const _hoisted_2 = { id: "overlay" }
const _hoisted_3 = { id: "sidebarContent" }
const _hoisted_4 = { "data-v-walkthrough": "map" }
const _hoisted_5 = { class: "horizontal_settings" }
const _hoisted_6 = { class: "setting" }
const _hoisted_7 = {
  key: 0,
  class: "error"
}
const _hoisted_8 = { class: "setting" }
const _hoisted_9 = {
  key: 0,
  class: "error"
}
const _hoisted_10 = { class: "setting" }
const _hoisted_11 = {
  key: 0,
  class: "error"
}
const _hoisted_12 = { style: {"display":"grid","grid-template-columns":"min-content auto","grid-template-rows":"min-content auto"} }
const _hoisted_13 = { style: {"position":"relative","aspect-ratio":"2 / 1"} }
const _hoisted_14 = {
  class: "setting",
  "data-v-walkthrough": "time-zone"
}
const _hoisted_15 = {
  class: "setting",
  "data-v-walkthrough": "sundial-type"
}
const _hoisted_16 = {
  class: "checkboxSetting",
  style: {"display":"flex","flex-direction":"row","align-items":"center"}
}
const _hoisted_17 = {
  class: "checkboxSetting",
  style: {"display":"flex","flex-direction":"row","align-items":"center"}
}
const _hoisted_18 = { "data-v-walkthrough": "slant-and-rotation" }
const _hoisted_19 = { class: "setting" }
const _hoisted_20 = {
  key: 0,
  class: "error"
}
const _hoisted_21 = { class: "setting" }
const _hoisted_22 = {
  key: 0,
  class: "error"
}
const _hoisted_23 = { class: "setting" }
const _hoisted_24 = { class: "fieldTitle" }
const _hoisted_25 = {
  key: 0,
  class: "error"
}
const _hoisted_26 = {
  class: "setting",
  "data-v-walkthrough": "hour-lines"
}
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "checkboxSetting" }
const _hoisted_29 = { class: "checkboxSetting" }
const _hoisted_30 = {
  key: 1,
  style: {"margin-left":"10px"}
}
const _hoisted_31 = { class: "checkboxSetting" }
const _hoisted_32 = { class: "checkboxSetting" }
const _hoisted_33 = { class: "checkboxSetting" }
const _hoisted_34 = { class: "checkboxSetting" }
const _hoisted_35 = { class: "checkboxSetting" }
const _hoisted_36 = { class: "checkboxSetting" }
const _hoisted_37 = { key: 0 }
const _hoisted_38 = { class: "setting" }
const _hoisted_39 = { class: "checkboxSetting" }
const _hoisted_40 = { class: "checkboxSetting" }
const _hoisted_41 = { class: "checkboxSetting" }
const _hoisted_42 = { class: "checkboxSetting" }
const _hoisted_43 = {
  for: "showPolarDayLine",
  class: "fieldOption"
}
const _hoisted_44 = { class: "variable-readout" }
const _hoisted_45 = { class: "checkboxSetting" }
const _hoisted_46 = {
  for: "showPolarNightLine",
  class: "fieldOption"
}
const _hoisted_47 = { class: "variable-readout" }
const _hoisted_48 = { class: "checkboxSetting" }
const _hoisted_49 = { class: "checkboxSetting" }
const _hoisted_50 = { class: "checkboxSetting" }
const _hoisted_51 = { id: "topRightControls" }
const _hoisted_52 = {
  id: "compassContainer",
  title: "North direction"
}
const _hoisted_53 = ["title"]
const _hoisted_54 = {
  src: _imports_4,
  height: "100%",
  alt: "Snap-to-top camera mode"
}
const _hoisted_55 = {
  src: _imports_5,
  height: "100%",
  alt: "Orbit camera mode"
}
const _hoisted_56 = {
  id: "status",
  "data-v-walkthrough": "status"
}
const _hoisted_57 = { style: {"display":"flex","flex-direction":"row","align-items":"center"} }
const _hoisted_58 = { style: {"display":"flex","margin-left":"10px","justify-content":"end","flex-direction":"column","align-items":"stretch","padding-block":"9px"} }
const _hoisted_59 = { class: "subtitle" }
const _hoisted_60 = { class: "subtitle" }
const _hoisted_61 = { class: "subtitle" }
const _hoisted_62 = { style: {"display":"flex","flex-direction":"row"} }
const _hoisted_63 = { class: "popper_content" }
const _hoisted_64 = { style: {"text-align":"left"} }
const _hoisted_65 = {
  class: "subtitle",
  style: {"margin-top":"13px"}
}

import { TresCanvas } from '@tresjs/core';
    import { onClickOutside } from '@vueuse/core'
    import interpolate from "color-interpolate";
    import { computed, getCurrentInstance, nextTick, onMounted, reactive, ref, watch } from 'vue'
    import SunObject from './components/SunObject.vue';
    import { decimal, helpers, maxValue, minValue, required } from '@vuelidate/validators';
    import useVuelidate from '@vuelidate/core';
    import { BasicShadowMap, Vector3, Euler, Quaternion } from 'three';
    import { dateToString, clamp, horizontalToActualCoords, calculateSunHorizontalCoordsFromUTC, timeToString, timeZoneToString, longitudeToTimeZone, stringToTime, calculatePolarDayDeclination, calculateObliquityOfTheEcliptic } from '@/calculations';
    import DialAndGnomonSundial from './components/DialAndGnomonSundial.vue';
    import CameraHelper from './components/CameraHelper.vue';
    import RendererHelper from './components/RendererHelper.vue';
    import ThreeTimesExplanation from './components/ThreeTimesExplanation.vue';
    import { tourSteps as walkthroughSteps } from './walkthrough';
    import Popper from 'vue3-popper';
    import PointSundial from './components/PointSundial.vue';
    import CompassObject from "./components/CompassObject.vue"
    
    /*
     * Config
     */
    const traditionalSundialRadius = 5;
    const pointSundialRadius = 4;
    const numeralDistanceFromSundialOrigin = 4;
    const zoomSpeed = 3;

    
    /*
     * Independent variables 
     */
    /** 0 to 24*60 */
    
export default /*@__PURE__*/_defineComponent({
  __name: 'App',
  setup(__props) {

_useCssVars(_ctx => ({
  "479a0b56": (statusTextColor.value)
}))


    const sundialOrigin = new Vector3(0, -0.5, 0);
    const cameraTarget = new Vector3(0, -1, 0)//sundialOrigin.clone();
    let localTime = ref<number>(12 * 60);
    /** 0 to 364 (integer) */
    let day = ref<number>(162);
    let longitude = ref<number>(0);
    let latitude = ref<number>(0);
    let autoSelectTimeZone = ref(true);
    /** +/- minutes UTC */
    let timeZone = ref<number>(0);
    let sunRaysPassThroughEarth = ref(false);
    let traditionalSundialHourLineStyle = ref<"solar"|"standard">("standard");
    let pointShadowTraceHourLineStyle = ref<"modern-local"|"modern-mean-solar"|"modern-apparent-solar"|"babylonian"|"italian"|"seasonal">("modern-local");
    let sundialType = ref<"dialAndGnomon" | "pointSundial">("dialAndGnomon")
    let slant = ref<number>(0);
    let rotation = ref<number>(0);
    /**Camera position multiplier per second. <1 zoom in, >1 zoom out */
    let currentZoomPerSecond = ref<number>(1);   
    let gnomonHeight = ref<number>(1)
    let showEquinoxLine = ref<boolean>(false)
    let showJuneSolsticeLine = ref<boolean>(true);
    let showDecemberSolsticeLine = ref<boolean>(true)
    let showPolarDayLine = ref<boolean>(true);
    let showPolarNightLine = ref<boolean>(true);
    let timeAdvanceSpeed = ref<number>(0)
    let alwaysDaySkyColor = ref<boolean>(false);
    let showSundialFaceGrid = ref<boolean>(false);
    let snapCamera = ref<boolean>(false);

    /**
     * readonly variables
     */
    let cameraQuaternion = ref<Quaternion>()

    /*
     * Allow the time to be input manually.
     */
    let isEditingTime = ref<boolean>(false);
    /** What's in the time manual entry box */
    let timeEntryValue = ref<string>("");
    const timeEntryBox = ref<HTMLInputElement | null>(null);   
    function showTimeEntryBox() {
        if (isEditingTime.value == false) {
            isEditingTime.value = true;
            timeEntryValue.value = timeToString(localTime.value);

            nextTick(() => timeEntryBox.value?.focus());
            
        }
    }
    function updateTimeFromEntryBox() {
        if (!timeEntryBox.value) return;

        const newTime = stringToTime(timeEntryBox.value.value);
        if (isNaN(newTime)) return;

        localTime.value = newTime;
    }
    function hideTimeEntryBox() {
        if (isEditingTime.value == true) {
            isEditingTime.value = false
            
            updateTimeFromEntryBox()
        }
    }
    onClickOutside(timeEntryBox, hideTimeEntryBox)

    // make the 3 times explanation popup disappear when escape key pressed
    onMounted(() => {
        document.addEventListener("keydown", (event) => {
            if (event.key == "Escape") {
                setShowThreeTimesExplanation(false)
            }
        })
    })
   


    /*
     * Sidebar form validation 
     */
    const formDefaults = {
        latitude:"45.00",
        longitude:"0.00",
        timeZone:"+0:00",
        slant:"0",
        rotation:"0",
        gnomonHeight:"1"
    }

    /** used to parse time zone user input*/
    const timeZoneRegex = /^\s*([+-±]?)\s*((?:0?[0-9])|1[0-9])(?::((?:0[0-9])|[1-5][0-9]))?\s*$/;

    let formState = reactive(formDefaults);
    const formRules = computed<Record<keyof typeof formDefaults, object>>(() => ({
        latitude: {
            required,
            decimal,
            minValue:minValue(-90),
            maxValue:maxValue(90)
        },
        longitude: {
            required,
            decimal,
            minValue:minValue(-180),
            maxValue:maxValue(180)
        },
        timeZone: {
            isATimeZone: helpers.withMessage("Your time zone should look like +/-HH(:MM)", helpers.regex(timeZoneRegex))
        },
        slant: {
            required,
            decimal,
            minValue:minValue(-180),
            maxValue:maxValue(180)
        },
        rotation: {
            required,
            decimal,
            minValue:minValue(-180),
            maxValue:maxValue(180)
        },
        gnomonHeight: {
            required,
            decimal,
            minValue:minValue(0.5),
            maxValue:maxValue(3)
        }
    }))
    const v$ = useVuelidate(formRules, formState)

    // parse and updadte whenever valid entries are changed in the form.
    watch(() => formState.longitude, newVal => {
        if (!v$.value.longitude.$invalid) {
            longitude.value = Number.parseFloat(newVal);
            // set the time zone as well.
            if (autoSelectTimeZone.value) {
                formState.timeZone = timeZoneToString(longitudeToTimeZone(longitude.value));
            }
        }
    }, { immediate: true })
    watch(() => formState.latitude, newVal => {
        if (!v$.value.latitude.$invalid) latitude.value = Number.parseFloat(newVal);
    }, {immediate:true})
    watch(() => formState.timeZone, newVal => {
        const result = newVal.match(timeZoneRegex);
        if (result) {
            const newValInt = (result[1] == "-" ? -1 : 1) * (Number.parseInt(result[2]) * 60 + Number.parseInt(result[3] ?? 0));
            // change the local time so that the global time remains consistent
            localTime.value = (((localTime.value + newValInt - timeZone.value) % 1440) + 1440) % 1440
            timeZone.value = newValInt;
        }
    }, {immediate:true})
    watch(() => formState.slant, newVal => {
        if (!v$.value.slant.$invalid) slant.value = Number.parseFloat(newVal) * Math.PI/180;
    }, {immediate: true})
    watch(() => formState.rotation, newVal => {
        if (!v$.value.rotation.$invalid) rotation.value = -Number.parseFloat(newVal) * Math.PI / 180;
    }, { immediate: true })
    watch(() => formState.gnomonHeight, newVal => {
        if (!v$.value.gnomonHeight.$invalid) gnomonHeight.value = Number.parseFloat(newVal);
    }, { immediate: true })


    const visibleDeclinationPlots = computed(() => {
        const plots: InstanceType<typeof PointSundial>["$props"]["declinationPlots"] = []
        if (showEquinoxLine.value) plots.push("equinox");
        if (showDecemberSolsticeLine.value) plots.push("december-solstice")
        if (showJuneSolsticeLine.value) plots.push("june-solstice")
        if (showPolarDayLine.value) plots.push("polar-day")
        if (showPolarNightLine.value) plots.push("polar-night")
        return plots
    })

    /*
    * Help popups
    */
    const instance = getCurrentInstance();
    let showThreeTimesExplanation = ref(false);
    function toggleWalkthrough() {
        const wt = instance?.appContext.config.globalProperties.$tours['walkthrough'];
        if (!wt) return;
        if (wt.isRunning.value) {
            wt.stop()
        } else {
            hideAllPoppers()
            wt.start()
        }
    }
    function hideAllPoppers() {
        instance?.appContext.config.globalProperties.$tours['walkthrough'].finish()
        showThreeTimesExplanation.value = false;
    }
    function setShowThreeTimesExplanation(show: boolean) {
        if (show) {
            hideAllPoppers()
        }
        showThreeTimesExplanation.value = show
    }
    const threeTimesExplanationPopper = ref();
    onClickOutside(threeTimesExplanationPopper, () => setShowThreeTimesExplanation(false))

    /**
     * Set the latitude and longitude when the user clicks on the map.
     */ 
    let mapImage = ref<HTMLImageElement>();
    let mapImageIsBeingClicked = ref(false);
    function setLatLngFromMap(offsetX: number, offsetY: number) {
        if (mapImage.value) {
            const longitude = clamp(offsetX / mapImage.value.width * 360 - 180, {min:-180, max:180})
            const latitude = clamp(90 - offsetY / mapImage.value.height * 180, {min:-90, max:90});
            formState.longitude = longitude.toFixed(1);
            formState.latitude = latitude.toFixed(1);
        }
    }
    function mapImageMouseMove(e:MouseEvent) {
        if (mapImageIsBeingClicked.value) setLatLngFromMap(e.offsetX, e.offsetY)
    }
    function mapImageTouchMove(e:TouchEvent) {
        // for touchscreens
        const rect = mapImage.value?.getBoundingClientRect()
        if (!rect) return
        const touch = e.touches[0]
        setLatLngFromMap(touch.clientX - rect.left, touch.clientY - rect.top)

    }
    function mapImageStartClicking() {
        mapImageIsBeingClicked.value = true;
    }
    function mapImageClick(e:MouseEvent) {
        setLatLngFromMap(e.offsetX, e.offsetY)
    }

    // global mouse released fn
    onMounted(() => {
        window.addEventListener("mouseup", () => {
            mapImageIsBeingClicked.value = false;
        })
    })

    // get the dimensions of the sidebar for layout
    let sidebarDims = ref({ clientWidth: 0, clientHeight: 0 });
    const sidebar = ref<HTMLDivElement>();
    const sidebarResizeObserver = new ResizeObserver(() => {
        const clientWidth = sidebar.value?.clientWidth ?? 0;
        const clientHeight = sidebar.value?.clientHeight ?? 0;
        sidebarDims.value = { clientWidth, clientHeight }
    })
    onMounted(() => {
        sidebarResizeObserver.observe(sidebar.value as HTMLDivElement);
    })


    // set the time zone as the user clicks the checkbox
    watch(() => autoSelectTimeZone.value, value => {
        if (value) {
            formState.timeZone = timeZoneToString(longitudeToTimeZone(longitude.value));
        }
    })

    function timeAdvanceButtonClicked() {
        if (timeAdvanceSpeed.value == 0) {
            timeAdvanceSpeed.value = 1
        } else {
            timeAdvanceSpeed.value *= 4
            if (timeAdvanceSpeed.value > 16) {
                timeAdvanceSpeed.value = 0
            }
        }
    }
    function advanceTime(mins:number) {
        localTime.value += mins
        if (localTime.value >= 1440) {
            localTime.value %= 1440
            day.value = (day.value + 1) % 365
        }
    }

    /**
     * computed values
     */
    const sundialRotation = computed(() => new Euler(Math.abs(slant.value), rotation.value + (slant.value < 0 ? Math.PI : 0), 0, "YXZ"));
    /** relative to sundial origin and rotation */
    const gnomonRelativePosition = computed(() => new Vector3(0, gnomonHeight.value, 0));
    const nodusRelativePosition = computed(() => new Vector3(0, gnomonHeight.value, 0));
    /** convert local time to UTC +0 */
    const time = computed(() => (((localTime.value - timeZone.value) % 1440) + 1440) % 1440)
    const sunHorizontalCoords = computed(() => calculateSunHorizontalCoordsFromUTC(day.value, time.value, latitude.value, longitude.value));
    const sunCoords = computed(() => horizontalToActualCoords(sunHorizontalCoords.value.azimuth, sunHorizontalCoords.value.altitude))
    // let gnomonRotation = computed(() => (90-latitude.value)*Math.PI/180);
    const isDaytime = computed(() => sunHorizontalCoords.value.altitude >= 0);
    const statusTextColor = computed(() => isDaytime.value || alwaysDaySkyColor.value ? "black" : "white")
    const timeText = computed(() => timeToString(localTime.value))
    const dateText = computed(() => dateToString(day.value));
    // mst is within 1 second of UTC at 0° longitude so this is fine
    const meanSolarTime = computed(() => time.value + ((longitude.value/360)*24*60));
    const meanSolarTimeText = computed(() => timeToString(meanSolarTime.value));
    const apparentSolarTime = computed(() => {
        // use the already-computed sun position. This isn't actualy dependent on the latitude irl. Just seemed the easiest way to do it here.
        // to calculate this, rotate sun position (90°-latitude) anticlockwise about x axis (west to east axis). Then work out projected angle in the x/z (horizontal) plane.
        const latRad = latitude.value * Math.PI/180;
        const timeHours = Math.atan2(sunCoords.value.y * Math.cos(latRad) + sunCoords.value.z * Math.sin(latRad), sunCoords.value.x) * 12 / Math.PI + 6;
        const timeMins = (((timeHours % 24) + 24) % 24) * 60;
        return timeMins;
    })
    const apparentSolarTimeText = computed(() => timeToString(apparentSolarTime.value))
    const timeZoneText = computed(() => timeZoneToString(timeZone.value))
    const sunlightIntensity = computed(() => {
        // a very unscientific way of calculating the apparent sunlight intensity.
        // stays at the same value until close to sunset (reasoning is that people's eyes adjust during the daytime)
        if (sunHorizontalCoords.value.altitude > 0.1) return 1;
        if (sunHorizontalCoords.value.altitude > 0) return sunHorizontalCoords.value.altitude/0.1;
        return 0;
    })
    const skyColor = computed(() => {
        if (alwaysDaySkyColor.value) {
            return "#87CEEB"
        }
        // 1: day, 0: night.
        let skyColorBrightness = 0
        if (sunHorizontalCoords.value.altitude > 0.1) skyColorBrightness = 1;
        else if (sunHorizontalCoords.value.altitude > -0.1) skyColorBrightness = (sunHorizontalCoords.value.altitude+0.1) / 0.2;
        // make the sky look nice innit
        return interpolate(["#02407a", "#87CEEB"])(skyColorBrightness);
    })
    /** brightness of sunlight on the sundial face, [0,1] */
    const sunlightSundialFaceIntensity = computed(() => {
        const sundialNormal = new Vector3(0, 1, 0).applyEuler(sundialRotation.value)
        const sunVector = new Vector3(sunCoords.value.x, sunCoords.value.y, sunCoords.value.z)
        // dot product: a.b = |a||b|cosθ.
        // cosθ is the intensity
        const intensity = sundialNormal.dot(sunVector) / (sundialNormal.length() * sunVector.length())
        if (intensity <= 0) return 0
        else return intensity * sunlightIntensity.value
    })
    const gridColorPalette = computed(() => sunlightSundialFaceIntensity.value >= 0.5 ? "light" : "dark")


    const timeAdvanceButtonText = computed(() => {
        if (timeAdvanceSpeed.value == 0) {
            return "▶"
        } else {
            return timeAdvanceSpeed.value + "x"
        }
    })


    const polarDayDeclination = computed(() => {
        const decl = calculatePolarDayDeclination(latitude.value);
        if (Math.abs(decl) * Math.PI/180 > calculateObliquityOfTheEcliptic(8400.5 + 132 /*2023*/)) {
            return null
        } else {
            return decl
        }
    })
    const polarDayDeclinationText = computed(() => polarDayDeclination.value ? polarDayDeclination.value.toFixed(1) + "°" : "n/a")
    const polarNightDeclinationText = computed(() => polarDayDeclination.value ? (-polarDayDeclination.value).toFixed(1) + "°" : "n/a")

    // previously all this stuff was inlined in the template
    // move all inline processing stuff in the <Tres...> tag props here because this is necessary to make tresjs render frames on demand
    // I have done this with most of the 3d components as well
    const showDialAndGnomonSundial = computed(() => sundialType.value === "dialAndGnomon")
    const showPointSundial = computed(() => sundialType.value === "pointSundial")
    const sunCoordsArray = computed<[number, number, number]>(() => [sunCoords.value.x, sunCoords.value.y, sunCoords.value.z])
    const directionalLightIntensity = computed(() => sunRaysPassThroughEarth.value ? 1 : sunlightIntensity.value)
    const cameraXOffset = computed(() => -(sidebarDims.value.clientWidth)/2)
    const gridHelperArgs = [50, 50, '#AAAAAA', '#AAAAAA'] as const
    const gridHelperPosition = [0, -8, 0] as const
    const compassCameraPosition = [0, 0, 10] as const
    const compassCameraLookAt = [0, 0, 0] as const


return (_ctx: any,_cache: any) => {
  const _component_v_tour = _resolveComponent("v-tour")!
  const _component_TresPerspectiveCamera = _resolveComponent("TresPerspectiveCamera")!
  const _component_TresOrthographicCamera = _resolveComponent("TresOrthographicCamera")!
  const _component_TresDirectionalLight = _resolveComponent("TresDirectionalLight")!
  const _component_TresAmbientLight = _resolveComponent("TresAmbientLight")!
  const _component_TresGridHelper = _resolveComponent("TresGridHelper")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_component_v_tour, {
      name: "walkthrough",
      steps: _unref(walkthroughSteps),
      options: {
        labels: {
            buttonSkip: 'Close',
            buttonPrevious: 'Previous',
            buttonNext: 'Next',
            buttonStop: 'Finish'
        }
    }
    }, null, 8, ["steps"]),
    _createElementVNode("div", _hoisted_1, [
      _createVNode(_unref(TresCanvas), {
        "clear-color": skyColor.value,
        shadows: "",
        shadowMapType: _unref(BasicShadowMap),
        "render-mode": "on-demand",
        id: "sundial"
      }, {
        default: _withCtx(() => [
          _createVNode(_component_TresPerspectiveCamera),
          _createVNode(_component_TresOrthographicCamera),
          _createVNode(DialAndGnomonSundial, {
            show: showDialAndGnomonSundial.value,
            latitude: _unref(latitude),
            longitude: _unref(longitude),
            origin: _unref(sundialOrigin),
            rotation: sundialRotation.value,
            "gnomon-position": gnomonRelativePosition.value,
            radius: traditionalSundialRadius,
            hourLineStyle: _unref(traditionalSundialHourLineStyle),
            "time-zone": _unref(timeZone),
            numeralDistanceFromSundialOrigin: numeralDistanceFromSundialOrigin,
            showGrid: _unref(showSundialFaceGrid),
            gridColorPalette: gridColorPalette.value
          }, null, 8, ["show", "latitude", "longitude", "origin", "rotation", "gnomon-position", "hourLineStyle", "time-zone", "showGrid", "gridColorPalette"]),
          _createVNode(PointSundial, {
            show: showPointSundial.value,
            latitude: _unref(latitude),
            longitude: _unref(longitude),
            origin: _unref(sundialOrigin),
            rotation: sundialRotation.value,
            "gnomon-position": nodusRelativePosition.value,
            radius: pointSundialRadius,
            hourLineStyle: _unref(pointShadowTraceHourLineStyle),
            "time-zone": _unref(timeZone),
            declinationPlots: visibleDeclinationPlots.value,
            localTime: _unref(localTime),
            day: _unref(day),
            showGrid: _unref(showSundialFaceGrid),
            gridColorPalette: gridColorPalette.value
          }, null, 8, ["show", "latitude", "longitude", "origin", "rotation", "gnomon-position", "hourLineStyle", "time-zone", "declinationPlots", "localTime", "day", "showGrid", "gridColorPalette"]),
          _createVNode(SunObject, { position: sunCoords.value }, null, 8, ["position"]),
          _createVNode(_component_TresDirectionalLight, {
            position: sunCoordsArray.value,
            intensity: directionalLightIntensity.value,
            "shadow-mapSize-width": 2048,
            "shadow-mapSize-height": 2048,
            "cast-shadow": ""
          }, null, 8, ["position", "intensity"]),
          _createVNode(_component_TresAmbientLight, { color: "#AAAAAA" }),
          _createVNode(_component_TresGridHelper, {
            args: gridHelperArgs,
            position: gridHelperPosition
          }),
          _createVNode(CameraHelper, {
            "x-offset": cameraXOffset.value,
            "zoom-per-second": _unref(currentZoomPerSecond),
            onCameraQuaternionChange: _cache[0] || (_cache[0] = q => _isRef(cameraQuaternion) //@ts-ignore
 ? cameraQuaternion.value = q.clone() : cameraQuaternion = q.clone()),
            onOnAdvanceTime: advanceTime,
            "time-advance-speed": _unref(timeAdvanceSpeed),
            target: _unref(cameraTarget),
            sundialOrigin: _unref(sundialOrigin),
            sundialRotation: sundialRotation.value,
            snapCamera: _unref(snapCamera)
          }, null, 8, ["x-offset", "zoom-per-second", "time-advance-speed", "target", "sundialOrigin", "sundialRotation", "snapCamera"]),
          _createVNode(RendererHelper)
        ]),
        _: 1
      }, 8, ["clear-color", "shadowMapType"])
    ]),
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", {
        id: "sidebar",
        ref_key: "sidebar",
        ref: sidebar
      }, [
        _createElementVNode("div", _hoisted_3, [
          _createElementVNode("a", {
            class: "sidebar_link",
            onClick: _cache[1] || (_cache[1] = e => {e.preventDefault(); toggleWalkthrough()}),
            href: "javascript:void(0)"
          }, "walkthrough"),
          _cache[85] || (_cache[85] = _createTextVNode(" · ", -1)),
          _cache[86] || (_cache[86] = _createElementVNode("a", {
            class: "sidebar_link",
            href: "https://github.com/tpeach90/sundials/",
            style: {"text-decoration":"none"},
            target: "_blank",
            title: "Source code on github.com"
          }, [
            _createElementVNode("span", { style: {"text-decoration":"underline"} }, "code"),
            _createElementVNode("img", {
              src: _imports_0,
              style: {"height":"1em","margin-left":"0.2em"},
              alt: "GitHub logo"
            })
          ], -1)),
          _cache[87] || (_cache[87] = _createElementVNode("h2", null, "Coordinates", -1)),
          _createElementVNode("div", _hoisted_4, [
            _createElementVNode("div", _hoisted_5, [
              _createElementVNode("div", _hoisted_6, [
                _cache[52] || (_cache[52] = _createElementVNode("label", { class: "fieldTitle" }, "Latitude/°", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "small_input",
                  "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((_unref(v$).latitude.$model) = $event))
                }, null, 512), [
                  [_vModelText, _unref(v$).latitude.$model]
                ]),
                (_unref(v$).latitude.$dirty && _unref(v$).latitude.$invalid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, _toDisplayString(_unref(v$).latitude.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_8, [
                _cache[53] || (_cache[53] = _createElementVNode("label", { class: "fieldTitle" }, "Longitude/°", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "small_input",
                  "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((_unref(v$).longitude.$model) = $event))
                }, null, 512), [
                  [_vModelText, _unref(v$).longitude.$model]
                ]),
                (_unref(v$).longitude.$dirty &&_unref(v$).longitude.$invalid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_9, _toDisplayString(_unref(v$).longitude.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ]),
              _createElementVNode("div", _hoisted_10, [
                _cache[54] || (_cache[54] = _createElementVNode("label", { class: "fieldTitle" }, "Time Zone/±UTC", -1)),
                _withDirectives(_createElementVNode("input", {
                  class: "small_input",
                  "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((_unref(v$).timeZone.$model) = $event))
                }, null, 512), [
                  [_vModelText, _unref(v$).timeZone.$model]
                ]),
                (_unref(v$).timeZone.$dirty && _unref(v$).timeZone.$invalid)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_11, _toDisplayString(_unref(v$).timeZone.$errors[0].$message), 1))
                  : _createCommentVNode("", true)
              ])
            ]),
            _createElementVNode("div", _hoisted_12, [
              _withDirectives(_createElementVNode("input", {
                style: {"grid-row":"1","grid-column":"1","margin-right":"10px","height":"100%","margin-top":"0px","margin-bottom":"0px","touch-action":"none"},
                type: "range",
                min: "-90",
                max: "90",
                step: "-0.1",
                class: "slider",
                orient: "vertical",
                "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((_unref(v$).latitude.$model) = $event))
              }, null, 512), [
                [_vModelText, _unref(v$).latitude.$model]
              ]),
              _createElementVNode("div", _hoisted_13, [
                _createElementVNode("img", {
                  src: _imports_1,
                  id: "mapImage",
                  alt: "A world map",
                  style: {"grid-row":"1","grid-column":"2","object-fit":"contain","display":"block","margin":"0px","touch-action":"none"},
                  draggable: "false",
                  onMousemove: mapImageMouseMove,
                  onMousedown: mapImageStartClicking,
                  onTouchstart: mapImageStartClicking,
                  onTouchmove: mapImageTouchMove,
                  onClick: mapImageClick,
                  ref_key: "mapImage",
                  ref: mapImage
                }, null, 544),
                _createElementVNode("div", {
                  id: "markerPoint",
                  style: _normalizeStyle(`top:${(90 - _unref(latitude)) * 100 / 180}%; left:${(_unref(longitude) + 180) * 100 / 360}%`)
                }, null, 4)
              ]),
              _withDirectives(_createElementVNode("input", {
                style: {"grid-row":"2","grid-column":"2","margin-top":"10px","margin-left":"0px","margin-right":"0px"},
                type: "range",
                min: "-180",
                max: "180",
                step: "1",
                class: "slider",
                "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((_unref(v$).longitude.$model) = $event))
              }, null, 512), [
                [_vModelText, _unref(v$).longitude.$model]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_14, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "autoSelectTimeZone",
              "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => (_isRef(autoSelectTimeZone) ? (autoSelectTimeZone).value = $event : autoSelectTimeZone = $event)),
              style: {"margin-right":"10px","display":"inline"}
            }, null, 512), [
              [_vModelCheckbox, _unref(autoSelectTimeZone)]
            ]),
            _cache[55] || (_cache[55] = _createElementVNode("label", {
              for: "autoSelectTimeZone",
              class: "fieldOption"
            }, "Automatically set time zone", -1))
          ]),
          _cache[88] || (_cache[88] = _createElementVNode("br", null, null, -1)),
          _cache[89] || (_cache[89] = _createElementVNode("h2", null, "Sundial Settings", -1)),
          _createElementVNode("div", _hoisted_15, [
            _createElementVNode("div", _hoisted_16, [
              _cache[57] || (_cache[57] = _createElementVNode("label", {
                for: "dialAndGnomon",
                style: {"margin-right":"10px"}
              }, [
                _createElementVNode("img", {
                  src: _imports_2,
                  style: {"width":"50px","aspect-ratio":"1/1"},
                  alt: "Traditional sundial icon"
                })
              ], -1)),
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "dialAndGnomon",
                  value: "dialAndGnomon",
                  "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => (_isRef(sundialType) ? (sundialType).value = $event : sundialType = $event))
                }, null, 512), [
                  [_vModelRadio, _unref(sundialType)]
                ]),
                _cache[56] || (_cache[56] = _createElementVNode("label", {
                  for: "dialAndGnomon",
                  class: "fieldOption"
                }, " Traditional sundial ", -1))
              ])
            ]),
            _createElementVNode("div", _hoisted_17, [
              _cache[59] || (_cache[59] = _createElementVNode("label", {
                for: "pointSundial",
                style: {"margin-right":"10px"}
              }, [
                _createElementVNode("img", {
                  src: _imports_3,
                  style: {"width":"50px","aspect-ratio":"1/1"},
                  alt: "Point shadow trace icon"
                })
              ], -1)),
              _createElementVNode("div", null, [
                _withDirectives(_createElementVNode("input", {
                  type: "radio",
                  id: "pointSundial",
                  value: "pointSundial",
                  "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => (_isRef(sundialType) ? (sundialType).value = $event : sundialType = $event))
                }, null, 512), [
                  [_vModelRadio, _unref(sundialType)]
                ]),
                _cache[58] || (_cache[58] = _createElementVNode("label", {
                  for: "pointSundial",
                  class: "fieldOption"
                }, " Point shadow trace ", -1))
              ])
            ])
          ]),
          _cache[90] || (_cache[90] = _createElementVNode("br", null, null, -1)),
          _createElementVNode("div", _hoisted_18, [
            _createElementVNode("div", _hoisted_19, [
              _cache[60] || (_cache[60] = _createElementVNode("label", { class: "fieldTitle" }, "Slant/°", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "small_input",
                "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((_unref(v$).slant.$model) = $event))
              }, null, 512), [
                [_vModelText, _unref(v$).slant.$model]
              ]),
              (_unref(v$).slant.$dirty && _unref(v$).slant.$invalid)
                ? (_openBlock(), _createElementBlock("div", _hoisted_20, _toDisplayString(_unref(v$).slant.$errors[0].$message), 1))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                min: -180,
                max: 180,
                step: "1",
                class: "slider",
                "onUpdate:modelValue": _cache[11] || (_cache[11] = ($event: any) => ((_unref(v$).slant.$model) = $event))
              }, null, 512), [
                [_vModelText, _unref(v$).slant.$model]
              ])
            ]),
            _createElementVNode("div", _hoisted_21, [
              _cache[61] || (_cache[61] = _createElementVNode("label", { class: "fieldTitle" }, "Rotation/°", -1)),
              _withDirectives(_createElementVNode("input", {
                class: "small_input",
                "onUpdate:modelValue": _cache[12] || (_cache[12] = ($event: any) => ((_unref(v$).rotation.$model) = $event))
              }, null, 512), [
                [_vModelText, _unref(v$).rotation.$model]
              ]),
              (_unref(v$).rotation.$dirty && _unref(v$).rotation.$invalid)
                ? (_openBlock(), _createElementBlock("div", _hoisted_22, _toDisplayString(_unref(v$).rotation.$errors[0].$message), 1))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                min: -180,
                max: 180,
                step: "1",
                class: "slider",
                "onUpdate:modelValue": _cache[13] || (_cache[13] = ($event: any) => ((_unref(v$).rotation.$model) = $event))
              }, null, 512), [
                [_vModelText, _unref(v$).rotation.$model]
              ])
            ]),
            _createElementVNode("div", _hoisted_23, [
              _createElementVNode("label", _hoisted_24, _toDisplayString(_unref(sundialType) == "dialAndGnomon" ? "Gnomon" : "Nodus") + " height", 1),
              _withDirectives(_createElementVNode("input", {
                class: "small_input",
                "onUpdate:modelValue": _cache[14] || (_cache[14] = ($event: any) => ((_unref(v$).gnomonHeight.$model) = $event))
              }, null, 512), [
                [_vModelText, _unref(v$).gnomonHeight.$model]
              ]),
              (_unref(v$).gnomonHeight.$dirty && _unref(v$).gnomonHeight.$invalid)
                ? (_openBlock(), _createElementBlock("div", _hoisted_25, _toDisplayString(_unref(v$).gnomonHeight.$errors[0].$message), 1))
                : _createCommentVNode("", true),
              _withDirectives(_createElementVNode("input", {
                type: "range",
                min: 0.5,
                max: 3,
                step: "0.05",
                class: "slider",
                "onUpdate:modelValue": _cache[15] || (_cache[15] = ($event: any) => ((_unref(v$).gnomonHeight.$model) = $event))
              }, null, 512), [
                [_vModelText, _unref(v$).gnomonHeight.$model]
              ])
            ])
          ]),
          _createElementVNode("div", _hoisted_26, [
            _cache[72] || (_cache[72] = _createElementVNode("label", { class: "fieldTitle" }, "Hour lines", -1)),
            (_unref(sundialType) == 'dialAndGnomon')
              ? (_openBlock(), _createElementBlock("div", _hoisted_27, [
                  _createElementVNode("div", _hoisted_28, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "standardLines",
                      value: "standard",
                      "onUpdate:modelValue": _cache[16] || (_cache[16] = ($event: any) => (_isRef(traditionalSundialHourLineStyle) ? (traditionalSundialHourLineStyle).value = $event : traditionalSundialHourLineStyle = $event))
                    }, null, 512), [
                      [_vModelRadio, _unref(traditionalSundialHourLineStyle)]
                    ]),
                    _cache[62] || (_cache[62] = _createElementVNode("label", {
                      for: "standardLines",
                      class: "fieldOption"
                    }, "Adjusted for time zone and longitude", -1))
                  ]),
                  _createElementVNode("div", _hoisted_29, [
                    _withDirectives(_createElementVNode("input", {
                      type: "radio",
                      id: "solarLines",
                      value: "solar",
                      "onUpdate:modelValue": _cache[17] || (_cache[17] = ($event: any) => (_isRef(traditionalSundialHourLineStyle) ? (traditionalSundialHourLineStyle).value = $event : traditionalSundialHourLineStyle = $event))
                    }, null, 512), [
                      [_vModelRadio, _unref(traditionalSundialHourLineStyle)]
                    ]),
                    _cache[63] || (_cache[63] = _createElementVNode("label", {
                      for: "solarLines",
                      class: "fieldOption"
                    }, "Apparent solar time", -1))
                  ])
                ]))
              : (_unref(sundialType)=='pointSundial')
                ? (_openBlock(), _createElementBlock("div", _hoisted_30, [
                    _cache[70] || (_cache[70] = _createElementVNode("label", { class: "fieldTitle" }, "Modern hours", -1)),
                    _createElementVNode("div", _hoisted_31, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "pstModernLocal",
                        value: "modern-local",
                        "onUpdate:modelValue": _cache[18] || (_cache[18] = ($event: any) => (_isRef(pointShadowTraceHourLineStyle) ? (pointShadowTraceHourLineStyle).value = $event : pointShadowTraceHourLineStyle = $event))
                      }, null, 512), [
                        [_vModelRadio, _unref(pointShadowTraceHourLineStyle)]
                      ]),
                      _cache[64] || (_cache[64] = _createElementVNode("label", {
                        for: "pstModernLocal",
                        class: "fieldOption"
                      }, "Local standard time", -1))
                    ]),
                    _createElementVNode("div", _hoisted_32, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "pstModernMeanSolar",
                        value: "modern-mean-solar",
                        "onUpdate:modelValue": _cache[19] || (_cache[19] = ($event: any) => (_isRef(pointShadowTraceHourLineStyle) ? (pointShadowTraceHourLineStyle).value = $event : pointShadowTraceHourLineStyle = $event))
                      }, null, 512), [
                        [_vModelRadio, _unref(pointShadowTraceHourLineStyle)]
                      ]),
                      _cache[65] || (_cache[65] = _createElementVNode("label", {
                        for: "pstModernMeanSolar",
                        class: "fieldOption"
                      }, "Mean solar time", -1))
                    ]),
                    _createElementVNode("div", _hoisted_33, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "pstModernApparentSolar",
                        value: "modern-apparent-solar",
                        "onUpdate:modelValue": _cache[20] || (_cache[20] = ($event: any) => (_isRef(pointShadowTraceHourLineStyle) ? (pointShadowTraceHourLineStyle).value = $event : pointShadowTraceHourLineStyle = $event))
                      }, null, 512), [
                        [_vModelRadio, _unref(pointShadowTraceHourLineStyle)]
                      ]),
                      _cache[66] || (_cache[66] = _createElementVNode("label", {
                        for: "pstModernApparentSolar",
                        class: "fieldOption"
                      }, "Apparent solar time", -1))
                    ]),
                    _cache[71] || (_cache[71] = _createElementVNode("label", {
                      class: "fieldTitle",
                      style: {"margin-top":"4px"}
                    }, [
                      _createTextVNode(" Other "),
                      _createElementVNode("a", {
                        class: "sidebar_link",
                        href: "https://www.bcgnomonics.com/types-of-hours",
                        title: "Explanation on bcgnomonics.com",
                        target: "_blank"
                      }, "(? - bcgnomonics.com)")
                    ], -1)),
                    _createElementVNode("div", _hoisted_34, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "pstBabylonian",
                        value: "babylonian",
                        "onUpdate:modelValue": _cache[21] || (_cache[21] = ($event: any) => (_isRef(pointShadowTraceHourLineStyle) ? (pointShadowTraceHourLineStyle).value = $event : pointShadowTraceHourLineStyle = $event))
                      }, null, 512), [
                        [_vModelRadio, _unref(pointShadowTraceHourLineStyle)]
                      ]),
                      _cache[67] || (_cache[67] = _createElementVNode("label", {
                        for: "pstBabylonian",
                        class: "fieldOption"
                      }, "Babylonian hours – hours from sunrise", -1))
                    ]),
                    _createElementVNode("div", _hoisted_35, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "pstItalian",
                        value: "italian",
                        "onUpdate:modelValue": _cache[22] || (_cache[22] = ($event: any) => (_isRef(pointShadowTraceHourLineStyle) ? (pointShadowTraceHourLineStyle).value = $event : pointShadowTraceHourLineStyle = $event))
                      }, null, 512), [
                        [_vModelRadio, _unref(pointShadowTraceHourLineStyle)]
                      ]),
                      _cache[68] || (_cache[68] = _createElementVNode("label", {
                        for: "pstItalian",
                        class: "fieldOption"
                      }, "Italian hours – hours from sunset", -1))
                    ]),
                    _createElementVNode("div", _hoisted_36, [
                      _withDirectives(_createElementVNode("input", {
                        type: "radio",
                        id: "pstSeasonal",
                        value: "seasonal",
                        "onUpdate:modelValue": _cache[23] || (_cache[23] = ($event: any) => (_isRef(pointShadowTraceHourLineStyle) ? (pointShadowTraceHourLineStyle).value = $event : pointShadowTraceHourLineStyle = $event))
                      }, null, 512), [
                        [_vModelRadio, _unref(pointShadowTraceHourLineStyle)]
                      ]),
                      _cache[69] || (_cache[69] = _createElementVNode("label", {
                        for: "pstSeasonal",
                        class: "fieldOption"
                      }, "Seasonal/unequal hours – sunrise to sunset", -1))
                    ])
                  ]))
                : _createCommentVNode("", true)
          ]),
          (_unref(sundialType) == 'pointSundial')
            ? (_openBlock(), _createElementBlock("div", _hoisted_37, [
                _cache[81] || (_cache[81] = _createElementVNode("br", null, null, -1)),
                _createElementVNode("div", _hoisted_38, [
                  _cache[80] || (_cache[80] = _createElementVNode("label", { class: "fieldTitle" }, "Constant-declination curves", -1)),
                  _createElementVNode("div", _hoisted_39, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "showJuneSolsticeLine",
                      "onUpdate:modelValue": _cache[24] || (_cache[24] = ($event: any) => (_isRef(showJuneSolsticeLine) ? (showJuneSolsticeLine).value = $event : showJuneSolsticeLine = $event)),
                      style: {"margin-right":"10px","display":"inline"}
                    }, null, 512), [
                      [_vModelCheckbox, _unref(showJuneSolsticeLine)]
                    ]),
                    _cache[73] || (_cache[73] = _createElementVNode("label", {
                      for: "showJuneSolsticeLine",
                      class: "fieldOption"
                    }, "June solstice (23.44°)", -1))
                  ]),
                  _createElementVNode("div", _hoisted_40, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "showDecemberSolsticeLine",
                      "onUpdate:modelValue": _cache[25] || (_cache[25] = ($event: any) => (_isRef(showDecemberSolsticeLine) ? (showDecemberSolsticeLine).value = $event : showDecemberSolsticeLine = $event)),
                      style: {"margin-right":"10px","display":"inline"}
                    }, null, 512), [
                      [_vModelCheckbox, _unref(showDecemberSolsticeLine)]
                    ]),
                    _cache[74] || (_cache[74] = _createElementVNode("label", {
                      for: "showDecemberSolsticeLine",
                      class: "fieldOption"
                    }, "December solstice (-23.44°)", -1))
                  ]),
                  _createElementVNode("div", _hoisted_41, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "showEquinoxLine",
                      "onUpdate:modelValue": _cache[26] || (_cache[26] = ($event: any) => (_isRef(showEquinoxLine) ? (showEquinoxLine).value = $event : showEquinoxLine = $event)),
                      style: {"margin-right":"10px","display":"inline"}
                    }, null, 512), [
                      [_vModelCheckbox, _unref(showEquinoxLine)]
                    ]),
                    _cache[75] || (_cache[75] = _createElementVNode("label", {
                      for: "showEquinoxLine",
                      class: "fieldOption"
                    }, "Equinox (0°)", -1))
                  ]),
                  _createElementVNode("div", _hoisted_42, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "showPolarDayLine",
                      "onUpdate:modelValue": _cache[27] || (_cache[27] = ($event: any) => (_isRef(showPolarDayLine) ? (showPolarDayLine).value = $event : showPolarDayLine = $event)),
                      style: {"margin-right":"10px","display":"inline"}
                    }, null, 512), [
                      [_vModelCheckbox, _unref(showPolarDayLine)]
                    ]),
                    _createElementVNode("label", _hoisted_43, [
                      _cache[76] || (_cache[76] = _createTextVNode("Polar day boundary (", -1)),
                      _createElementVNode("div", _hoisted_44, _toDisplayString(polarDayDeclinationText.value), 1),
                      _cache[77] || (_cache[77] = _createTextVNode(")", -1))
                    ])
                  ]),
                  _createElementVNode("div", _hoisted_45, [
                    _withDirectives(_createElementVNode("input", {
                      type: "checkbox",
                      id: "showPolarNightLine",
                      "onUpdate:modelValue": _cache[28] || (_cache[28] = ($event: any) => (_isRef(showPolarNightLine) ? (showPolarNightLine).value = $event : showPolarNightLine = $event)),
                      style: {"margin-right":"10px","display":"inline"}
                    }, null, 512), [
                      [_vModelCheckbox, _unref(showPolarNightLine)]
                    ]),
                    _createElementVNode("label", _hoisted_46, [
                      _cache[78] || (_cache[78] = _createTextVNode("Polar night boundary (", -1)),
                      _createElementVNode("div", _hoisted_47, _toDisplayString(polarNightDeclinationText.value), 1),
                      _cache[79] || (_cache[79] = _createTextVNode(")", -1))
                    ])
                  ])
                ])
              ]))
            : _createCommentVNode("", true),
          _cache[91] || (_cache[91] = _createElementVNode("br", null, null, -1)),
          _cache[92] || (_cache[92] = _createElementVNode("h2", null, "Misc", -1)),
          _createElementVNode("div", _hoisted_48, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "showSundialFaceGrid",
              "onUpdate:modelValue": _cache[29] || (_cache[29] = ($event: any) => (_isRef(showSundialFaceGrid) ? (showSundialFaceGrid).value = $event : showSundialFaceGrid = $event))
            }, null, 512), [
              [_vModelCheckbox, _unref(showSundialFaceGrid)]
            ]),
            _cache[82] || (_cache[82] = _createElementVNode("label", {
              for: "showSundialFaceGrid",
              class: "fieldOption"
            }, "Sundial grid overlay", -1))
          ]),
          _createElementVNode("div", _hoisted_49, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "sunRaysPassThroughEarth",
              "onUpdate:modelValue": _cache[30] || (_cache[30] = ($event: any) => (_isRef(sunRaysPassThroughEarth) ? (sunRaysPassThroughEarth).value = $event : sunRaysPassThroughEarth = $event))
            }, null, 512), [
              [_vModelCheckbox, _unref(sunRaysPassThroughEarth)]
            ]),
            _cache[83] || (_cache[83] = _createElementVNode("label", {
              for: "sunRaysPassThroughEarth",
              class: "fieldOption"
            }, "Light can reach the sundial at night", -1))
          ]),
          _createElementVNode("div", _hoisted_50, [
            _withDirectives(_createElementVNode("input", {
              type: "checkbox",
              id: "alwaysDaySkyColor",
              "onUpdate:modelValue": _cache[31] || (_cache[31] = ($event: any) => (_isRef(alwaysDaySkyColor) ? (alwaysDaySkyColor).value = $event : alwaysDaySkyColor = $event))
            }, null, 512), [
              [_vModelCheckbox, _unref(alwaysDaySkyColor)]
            ]),
            _cache[84] || (_cache[84] = _createElementVNode("label", {
              for: "alwaysDaySkyColor",
              class: "fieldOption"
            }, "Disable night-time dark sky color", -1))
          ]),
          _cache[93] || (_cache[93] = _createElementVNode("br", null, null, -1)),
          _cache[94] || (_cache[94] = _createElementVNode("footer", null, [
            _createElementVNode("p", { id: "copyrightText" }, [
              _createTextVNode("© Thomas Peach 2025. "),
              _createElementVNode("a", {
                class: "sidebar_link",
                href: "mailto:thomas.peach546@gmail.com"
              }, "Contact")
            ])
          ], -1))
        ])
      ], 512),
      _createElementVNode("div", _hoisted_51, [
        _createElementVNode("div", _hoisted_52, [
          _createVNode(_unref(TresCanvas), { "render-mode": "on-demand" }, {
            default: _withCtx(() => [
              _createVNode(_component_TresAmbientLight, {
                color: "#FFFFFF",
                intensity: 2
              }),
              _createVNode(_component_TresOrthographicCamera, {
                position: compassCameraPosition,
                lookAt: compassCameraLookAt,
                zoom: 15
              }),
              _createVNode(CompassObject, { sundialCameraQuaternion: _unref(cameraQuaternion) }, null, 8, ["sundialCameraQuaternion"])
            ]),
            _: 1
          }),
          _cache[95] || (_cache[95] = _createElementVNode("div", {
            style: {"position":"absolute","width":"100%","height":"100%","top":"0","left":"0"},
            title: "North"
          }, null, -1))
        ]),
        _createElementVNode("button", {
          class: "zoomControl",
          onKeydown: _cache[32] || (_cache[32] = _withKeys(() => { _isRef(currentZoomPerSecond) //@ts-ignore
 ? currentZoomPerSecond.value = 1 / zoomSpeed : currentZoomPerSecond = 1 / zoomSpeed }, ["enter"])),
          onKeyup: _cache[33] || (_cache[33] = _withKeys(() => { _isRef(currentZoomPerSecond) //@ts-ignore
 ? currentZoomPerSecond.value = 1 : currentZoomPerSecond = 1 }, ["enter"])),
          onMousedown: _cache[34] || (_cache[34] = () => { _isRef(currentZoomPerSecond) //@ts-ignore
 ? currentZoomPerSecond.value = 1 / zoomSpeed : currentZoomPerSecond = 1 / zoomSpeed }),
          onMouseup: _cache[35] || (_cache[35] = () => { _isRef(currentZoomPerSecond) //@ts-ignore
 ? currentZoomPerSecond.value = 1 : currentZoomPerSecond = 1 }),
          onPointerleave: _cache[36] || (_cache[36] = () => { _isRef(currentZoomPerSecond) //@ts-ignore
 ? currentZoomPerSecond.value = 1 : currentZoomPerSecond = 1 }),
          onTouchstart: _cache[37] || (_cache[37] = () => { _isRef(currentZoomPerSecond) //@ts-ignore
 ? currentZoomPerSecond.value = 1 / zoomSpeed : currentZoomPerSecond = 1 / zoomSpeed }),
          onTouchend: _cache[38] || (_cache[38] = () => { _isRef(currentZoomPerSecond) //@ts-ignore
 ? currentZoomPerSecond.value = 1 : currentZoomPerSecond = 1 }),
          title: "Zoom in"
        }, " + ", 32),
        _createElementVNode("button", {
          class: "zoomControl",
          onKeydown: _cache[39] || (_cache[39] = _withKeys(() => { _isRef(currentZoomPerSecond) //@ts-ignore
 ? currentZoomPerSecond.value = zoomSpeed : currentZoomPerSecond = zoomSpeed }, ["enter"])),
          onKeyup: _cache[40] || (_cache[40] = _withKeys(() => { _isRef(currentZoomPerSecond) //@ts-ignore
 ? currentZoomPerSecond.value = 1 : currentZoomPerSecond = 1 }, ["enter"])),
          onMousedown: _cache[41] || (_cache[41] = () => { _isRef(currentZoomPerSecond) //@ts-ignore
 ? currentZoomPerSecond.value = zoomSpeed : currentZoomPerSecond = zoomSpeed }),
          onMouseup: _cache[42] || (_cache[42] = () => { _isRef(currentZoomPerSecond) //@ts-ignore
 ? currentZoomPerSecond.value = 1 : currentZoomPerSecond = 1 }),
          onPointerleave: _cache[43] || (_cache[43] = () => { _isRef(currentZoomPerSecond) //@ts-ignore
 ? currentZoomPerSecond.value = 1 : currentZoomPerSecond = 1 }),
          onTouchstart: _cache[44] || (_cache[44] = () => { _isRef(currentZoomPerSecond) //@ts-ignore
 ? currentZoomPerSecond.value = zoomSpeed : currentZoomPerSecond = zoomSpeed }),
          onTouchend: _cache[45] || (_cache[45] = () => { _isRef(currentZoomPerSecond) //@ts-ignore
 ? currentZoomPerSecond.value = 1 : currentZoomPerSecond = 1 }),
          title: "Zoom out"
        }, " - ", 32),
        _createElementVNode("button", {
          class: "zoomControl",
          onClick: _cache[46] || (_cache[46] = () => _isRef(snapCamera) //@ts-ignore
 ? snapCamera.value = !_unref(snapCamera) : snapCamera = !_unref(snapCamera)),
          title: _unref(snapCamera) ? 'Switch to orbit camera' : 'Switch to snap-to-top camera'
        }, [
          _withDirectives(_createElementVNode("img", _hoisted_54, null, 512), [
            [_vShow, _unref(snapCamera)]
          ]),
          _withDirectives(_createElementVNode("img", _hoisted_55, null, 512), [
            [_vShow, !_unref(snapCamera)]
          ])
        ], 8, _hoisted_53)
      ]),
      _createElementVNode("div", _hoisted_56, [
        _createElementVNode("div", _hoisted_57, [
          _withDirectives(_createElementVNode("div", {
            class: "time_display",
            onClick: showTimeEntryBox,
            onKeydown: _withKeys(showTimeEntryBox, ["space"]),
            tabindex: "0"
          }, _toDisplayString(timeText.value), 545), [
            [_vShow, !_unref(isEditingTime)]
          ]),
          _withDirectives(_createElementVNode("input", {
            ref_key: "timeEntryBox",
            ref: timeEntryBox,
            class: "timeEntryBox",
            onBlur: hideTimeEntryBox,
            onKeydown: [
              _withKeys(hideTimeEntryBox, ["enter"]),
              _withKeys(hideTimeEntryBox, ["esc"])
            ],
            onInput: updateTimeFromEntryBox,
            "onUpdate:modelValue": _cache[47] || (_cache[47] = ($event: any) => (_isRef(timeEntryValue) ? (timeEntryValue).value = $event : timeEntryValue = $event))
          }, null, 544), [
            [_vShow, _unref(isEditingTime)],
            [_vModelText, _unref(timeEntryValue)]
          ]),
          _withDirectives(_createElementVNode("div", _hoisted_58, [
            _cache[96] || (_cache[96] = _createElementVNode("div", { class: "subtitle" }, "local standard time", -1)),
            _createElementVNode("div", _hoisted_59, "(UTC " + _toDisplayString(timeZoneText.value) + ") " + _toDisplayString(isDaytime.value ? "☀️" : "🌙"), 1)
          ], 512), [
            [_vShow, !_unref(isEditingTime)]
          ])
        ]),
        _createElementVNode("div", _hoisted_60, _toDisplayString(meanSolarTimeText.value) + " mean solar time", 1),
        _createElementVNode("div", _hoisted_61, _toDisplayString(apparentSolarTimeText.value) + " apparent solar time", 1),
        _createElementVNode("div", _hoisted_62, [
          _withDirectives(_createElementVNode("input", {
            type: "range",
            min: "0",
            max: "1440",
            step: "10",
            class: "slider",
            id: "time",
            "onUpdate:modelValue": _cache[48] || (_cache[48] = ($event: any) => (_isRef(localTime) ? (localTime).value = $event : localTime = $event))
          }, null, 512), [
            [
              _vModelText,
              _unref(localTime),
              void 0,
              { number: true }
            ]
          ]),
          _createElementVNode("button", {
            type: "button",
            onClick: timeAdvanceButtonClicked,
            id: "time_advance_button",
            title: "Auto-advance time"
          }, _toDisplayString(timeAdvanceButtonText.value), 1)
        ]),
        _createVNode(_unref(Popper), {
          arrow: "",
          placement: "left",
          show: _unref(showThreeTimesExplanation),
          ref_key: "threeTimesExplanationPopper",
          ref: threeTimesExplanationPopper
        }, {
          content: _withCtx(() => [
            _createElementVNode("div", _hoisted_63, [
              _createElementVNode("div", _hoisted_64, [
                _createVNode(ThreeTimesExplanation)
              ]),
              _createElementVNode("button", {
                class: "v-step__button",
                onClick: _cache[49] || (_cache[49] = () => setShowThreeTimesExplanation(false))
              }, "Close")
            ])
          ]),
          default: _withCtx(() => [
            _createElementVNode("a", {
              class: "overlay_link",
              href: "javascript:void(0)",
              onClick: _cache[50] || (_cache[50] = () => setShowThreeTimesExplanation(!_unref(showThreeTimesExplanation)))
            }, "Why are there 3 times?")
          ]),
          _: 1
        }, 8, ["show"]),
        _cache[97] || (_cache[97] = _createElementVNode("hr", null, null, -1)),
        _createElementVNode("div", _hoisted_65, _toDisplayString(dateText.value), 1),
        _withDirectives(_createElementVNode("input", {
          type: "range",
          min: "0",
          max: "364",
          step: "1",
          class: "slider",
          id: "day",
          "onUpdate:modelValue": _cache[51] || (_cache[51] = ($event: any) => (_isRef(day) ? (day).value = $event : day = $event))
        }, null, 512), [
          [
            _vModelText,
            _unref(day),
            void 0,
            { number: true }
          ]
        ])
      ])
    ])
  ], 64))
}
}

})